import {call, put, takeEvery} from 'redux-saga/effects';
import {api} from "../../api/api";
import {cardsActions, SetStatePayload} from "../cards.slice";
import {PayloadAction} from "@reduxjs/toolkit";
import {SetStateResult} from "../../common";

function* moveSaga(action: PayloadAction<SetStatePayload>) {
    const result: SetStateResult = yield call(api.setState, {
        cardId: action.payload.cardId,
        state: action.payload.state,
    });

    for (const cardId of result.updatedCardIds) {
        yield put(cardsActions.setState({cardId, state: action.payload.state}));
    }
}

export function* moveToStateSaga() {
    yield takeEvery(cardsActions.moveToState.type, moveSaga);
}
